export const STATI = [
  ["da_avviare", "Da avviare", "#64748B"],
  ["inviata", "Inviata", "#1565C0"],
  ["fase_1", "Fase 1", "#0277BD"],
  ["pronto_fase_2", "Pronto Fase 2", "#00838F"],
  ["fase_2", "Fase 2", "#00695C"],
  ["preventivo_ricevuto", "Preventivo ricevuto", "#EF6C00"],
  ["accettazione_preventivo", "Accettazione preventivo", "#AD5B00"],
  ["conferma_fine_opere", "Conferma fine opere", "#6A1B9A"],
  ["attivata", "Attivata", "#2E7D32"],
];
export const statoInfo = (k) => STATI.find((s) => s[0] === k) || STATI[0];
export const TIPI = { semplificata: "Semplificata", ordinaria: "Ordinaria" };
export const DISTRIBUTORI = ["E-Distribuzione", "Areti", "Unareti", "Ireti", "Edyna", "Inrete Distribuzione", "Set Distribuzione", "Deval"];
export const GAUDI_URL = "https://www.terna.it/it/sistema-elettrico/gaudi";
export const EMPTY = {
  soggetto_titolare: "", codice_pratica: "", pod: "", data_assegnazione: "", data_inoltro: "",
  tipo_pratica: "semplificata", stato: "da_avviare", commessa_id: "", portale_distributore: "",
  gaudi_aperta: false, codice_gaudi: "", note: "",
};
export const inputCls = "w-full mt-1 px-3 py-2 text-sm rounded-md border outline-none";
export const inputStyle = { borderColor: "var(--border)", background: "#fff" };
export const lblCls = "text-xs font-semibold uppercase tracking-wider";
export const fmtDate = (d) => (d ? new Date(d).toLocaleDateString("it-IT") : "—");
